module.exports = __webpack_public_path__ + "assets/img/fangan03.202ac725.png";